<form class="password-change-dialog" (ngSubmit)="changePassword()" #passwordExpiredLogin="ngForm">
  <div class="form-group">
    <label><strong>{{'CHANGE_PASSWORD' |translate}}</strong></label>

    @if (enhancedSecurity) {
      <p class="text-muted small">{{'PASSWORD_PASSPHRASE_HINT' |translate}}</p>
    }
    @if (!enhancedSecurity) {
      <p>{{'PASSWORD_INFO' |translate}}</p>
    }

    @if (passwordChangeError) {
      <p class="text-danger">
        {{passwordChangeError |translate}}
      </p>
    }
  </div>
  <div class="form-group">
    <input class="form-control" type="password" placeholder="{{'OLD_PASSWORD' |translate}}"
      [(ngModel)]="expiredOldPassword" name="expiredOldPasswordElement" #expiredOldPasswordElement="ngModel"
      required>
    </div>
    <div class="form-group">
      <input class="form-control"
        [pattern]="enhancedSecurity ? '(?=.*\\S)[\\s\\S]{12,}' : '(?=.*\\S)[\\s\\S]{6,}'"
        type="password" placeholder="{{'NEW_PASSWORD' |translate}}" [(ngModel)]="expiredNewPassword"
        name="expiredNewPasswordElement"
        #expiredNewPasswordElement="ngModel" required>
      @if (enhancedSecurity && expiredNewPasswordElement.dirty && expiredNewPasswordElement.errors?.pattern) {
        <p class="text-danger small">{{'PasswordTooShort' | translate}}</p>
      }
      </div>
      <div class="form-group">
        <input class="form-control"
          [pattern]="enhancedSecurity ? '(?=.*\\S)[\\s\\S]{12,}' : '(?=.*\\S)[\\s\\S]{6,}'"
          type="password" placeholder="{{'CONFIRM_NEW_PASSWORD' |translate}}" [(ngModel)]="expiredNewPasswordConfirm"
          name="expiredNewPasswordConfirmElement" #expiredNewPasswordConfirmElement="ngModel" required>
        @if (enhancedSecurity && expiredNewPasswordConfirmElement.dirty && expiredNewPasswordConfirmElement.errors?.pattern) {
          <p class="text-danger small">{{'PasswordTooShort' | translate}}</p>
        }
        </div>
        <div class="form-group">
          <button [disabled]="passwordExpiredLogin.invalid" class="btn btn-outline-primary" type="submit"><span
          class="fa-light fa-fw fa-key"></span> {{'CHANGE_PASSWORD' |translate}}</button>
          <button [mat-dialog-close]="true" class="btn btn-outline-danger ml-2"><span
          class="fa-light fa-fw fa-xmark"></span> {{'CANCEL' |translate}}</button>
        </div>
      </form>